import { __spread } from 'tslib';
import { EventEmitter, Component, Input, Output, HostListener, ViewEncapsulation, ViewChild, ViewContainerRef, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/actions.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Represents row actions on a row in the
 * data table.
 * @record
 */
function iAction() { }
if (false) {
    /** @type {?} */
    iAction.prototype.title;
    /** @type {?} */
    iAction.prototype.icon;
    /** @type {?|undefined} */
    iAction.prototype.condition;
    /** @type {?} */
    iAction.prototype.command;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/built-in-templates.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var BuiltInTemplates = {
    DATE: 0,
    NUMBER: 1,
};
BuiltInTemplates[BuiltInTemplates.DATE] = 'DATE';
BuiltInTemplates[BuiltInTemplates.NUMBER] = 'NUMBER';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/column-alignment.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var ColumnAlignment = {
    CENTER: 0,
    LEFT: 1,
    RIGHT: 2,
};
ColumnAlignment[ColumnAlignment.CENTER] = 'CENTER';
ColumnAlignment[ColumnAlignment.LEFT] = 'LEFT';
ColumnAlignment[ColumnAlignment.RIGHT] = 'RIGHT';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/column.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The column object to configure the
 * rendered column in the grid
 */
var  /**
 * The column object to configure the
 * rendered column in the grid
 */
Column = /** @class */ (function () {
    function Column() {
        /**
         * Optional algnment of the row data
         */
        this.alignment = ColumnAlignment.LEFT;
        /**
         * Order of the column
         */
        this.order = 0;
    }
    return Column;
}());
if (false) {
    /**
     * Should it display in the grid
     * @type {?}
     */
    Column.prototype.display;
    /**
     * Optional template / DOM to render as the column-header
     * @type {?}
     */
    Column.prototype.headerTemplate;
    /**
     * Optional template / DOM to render in the grid
     * @type {?}
     */
    Column.prototype.cellTemplate;
    /**
     * Optional template / DOM to render in the overflow detail section when
     * expanded
     * @type {?}
     */
    Column.prototype.overflowTemplate;
    /**
     * The column name / caption
     * @type {?}
     */
    Column.prototype.name;
    /**
     * The property of the row to render
     * @type {?}
     */
    Column.prototype.prop;
    /**
     * Optional algnment of the row data
     * @type {?}
     */
    Column.prototype.alignment;
    /**
     * Order of the column
     * @type {?}
     */
    Column.prototype.order;
    /**
     * Will make the grid inject a textbox to edit the data
     * NOTE: For now it will only be a textbox, we can extend this in the future
     * @type {?}
     */
    Column.prototype.editable;
    /** @type {?} */
    Column.prototype.class;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/expandable-types.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var ExpandableTypes = {
    NONE: 0,
    ALL: 1,
    ROW_DRIVEN: 2,
};
ExpandableTypes[ExpandableTypes.NONE] = 'NONE';
ExpandableTypes[ExpandableTypes.ALL] = 'ALL';
ExpandableTypes[ExpandableTypes.ROW_DRIVEN] = 'ROW_DRIVEN';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/page.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 *  Model for the paging in the data table
 */
var  /**
 *  Model for the paging in the data table
 */
Page = /** @class */ (function () {
    function Page() {
        /**
         * The number of elements in the page
         */
        this.size = 0;
        /**
         * The total number of elements
         */
        this.totalElements = 0;
        /**
         * The total number of pages
         */
        this.totalPages = 0;
        /**
         * The current page number
         */
        this.currentPage = 0;
    }
    return Page;
}());
if (false) {
    /**
     * The number of elements in the page
     * @type {?}
     */
    Page.prototype.size;
    /**
     * The total number of elements
     * @type {?}
     */
    Page.prototype.totalElements;
    /**
     * The total number of pages
     * @type {?}
     */
    Page.prototype.totalPages;
    /**
     * The current page number
     * @type {?}
     */
    Page.prototype.currentPage;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/paging.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var Paging = {
    NONE: 1,
    PAGED: 2,
    AUTO: 3,
};
Paging[Paging.NONE] = 'NONE';
Paging[Paging.PAGED] = 'PAGED';
Paging[Paging.AUTO] = 'AUTO';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/row-expand-states.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var RowExpandStates = {
    PARTIAL: 0,
    EXPANDED: 1,
    COLLAPSED: 2,
};
RowExpandStates[RowExpandStates.PARTIAL] = 'PARTIAL';
RowExpandStates[RowExpandStates.EXPANDED] = 'EXPANDED';
RowExpandStates[RowExpandStates.COLLAPSED] = 'COLLAPSED';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/row-selection-args.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function RowSelectionArgs() { }
if (false) {
    /** @type {?} */
    RowSelectionArgs.prototype.rows;
    /** @type {?} */
    RowSelectionArgs.prototype.pageSize;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/selectable-types.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var SelectableTypes = {
    NONE: 0,
    ALL: 1,
    ROW_DRIVEN: 2,
};
SelectableTypes[SelectableTypes.NONE] = 'NONE';
SelectableTypes[SelectableTypes.ALL] = 'ALL';
SelectableTypes[SelectableTypes.ROW_DRIVEN] = 'ROW_DRIVEN';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/settings-panel-models.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SettingsPanelConfig = /** @class */ (function () {
    function SettingsPanelConfig(version) {
        /**
         * Version of the settings panel config.
         * If something changes, please increment this number in this file.
         */
        this.Version = 1;
        this.PersistedColumns = [];
        if (version)
            this.Version = version;
    }
    return SettingsPanelConfig;
}());
if (false) {
    /**
     * Version of the settings panel config.
     * If something changes, please increment this number in this file.
     * @type {?}
     */
    SettingsPanelConfig.prototype.Version;
    /** @type {?} */
    SettingsPanelConfig.prototype.PersistedColumns;
}
var PersistedColumnsSet = /** @class */ (function () {
    function PersistedColumnsSet() {
    }
    return PersistedColumnsSet;
}());
if (false) {
    /** @type {?} */
    PersistedColumnsSet.prototype.UniqueKey;
    /** @type {?} */
    PersistedColumnsSet.prototype.Columns;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/sort-direction.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var SortDirection = {
    UNKNOWN: 0,
    ASC: 1,
    DESC: -1,
};
SortDirection[SortDirection.UNKNOWN] = 'UNKNOWN';
SortDirection[SortDirection.ASC] = 'ASC';
SortDirection[SortDirection.DESC] = 'DESC';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/settings-panel/settings-panel.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SettingsComponent = /** @class */ (function () {
    function SettingsComponent() {
        this.show = false;
        this.MinimumColumns = 5;
        this.OnColumnsChanged = new EventEmitter();
        this.columns = [];
        this.originalColumns = [];
        /**
         * Unique key of the table to save the columns for
         */
        this.UniqueKey = '';
        /**
         * Indicates if we should save the settings or not
         */
        this.PersistColumnSettings = false;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    SettingsComponent.prototype.documentClick = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.show = false;
    };
    /**
     * Method called from the datatable to set the
     * columns in the panel.
     * @param cols Columns to populate the panel with
     */
    /**
     * Method called from the datatable to set the
     * columns in the panel.
     * @param {?} cols Columns to populate the panel with
     * @return {?}
     */
    SettingsComponent.prototype.setColumns = /**
     * Method called from the datatable to set the
     * columns in the panel.
     * @param {?} cols Columns to populate the panel with
     * @return {?}
     */
    function (cols) {
        this.originalColumns = [];
        this.columns = [];
        this.columns.length = 0;
        this.originalColumns.length = 0;
        this.originalColumns = __spread(cols);
        this.columns = __spread(cols);
        // Now we can actually sort on this order
        this.columns.sort((/**
         * @param {?} a
         * @param {?} b
         * @return {?}
         */
        function (a, b) { return (a.display > b.display ? -1 : 1); }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    SettingsComponent.prototype.stopPropagation = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        event.stopPropagation();
    };
    /**
     * @return {?}
     */
    SettingsComponent.prototype.resetColumns = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.columns = __spread(this.originalColumns);
        this.columns.map((/**
         * @param {?} column
         * @param {?} index
         * @return {?}
         */
        function (column, index) { return (column.display = index < _this.MinimumColumns); }));
        this.lastModifiedColumnIndex = null;
    };
    /**
     * @param {?} order
     * @param {?=} index
     * @return {?}
     */
    SettingsComponent.prototype.moveColumnUp = /**
     * @param {?} order
     * @param {?=} index
     * @return {?}
     */
    function (order, index) {
        if (order >= 1)
            this.swapColumnOrder(order, order - 1);
        this.lastModifiedColumnIndex = order - 1;
    };
    /**
     * @param {?} order
     * @param {?=} index
     * @return {?}
     */
    SettingsComponent.prototype.moveColumnDown = /**
     * @param {?} order
     * @param {?=} index
     * @return {?}
     */
    function (order, index) {
        if (order < this.columns.length) {
            this.swapColumnOrder(order, order + 1);
        }
        this.lastModifiedColumnIndex = order + 1;
    };
    /**
     * @param {?} x
     * @param {?} y
     * @return {?}
     */
    SettingsComponent.prototype.swapColumnOrder = /**
     * @param {?} x
     * @param {?} y
     * @return {?}
     */
    function (x, y) {
        /** @type {?} */
        var initialColumnOrder = this.columns[x].order;
        this.columns[x].order = this.columns[y].order;
        this.columns[y].order = initialColumnOrder;
        this.columns = this.columns.sort((/**
         * @param {?} a
         * @param {?} b
         * @return {?}
         */
        function (a, b) { return a.order - b.order; }));
    };
    /**
     * @return {?}
     */
    SettingsComponent.prototype.validColumnCount = /**
     * @return {?}
     */
    function () {
        return (this.columns.filter((/**
         * @param {?} c
         * @return {?}
         */
        function (c) { return c.display; })).length === this.MinimumColumns);
    };
    /**
     * @return {?}
     */
    SettingsComponent.prototype.cancel = /**
     * @return {?}
     */
    function () {
        this.resetColumns();
        this.show = false;
    };
    /**
     * @return {?}
     */
    SettingsComponent.prototype.save = /**
     * @return {?}
     */
    function () {
        // If we save, we make our original columns our
        this.OnColumnsChanged.emit(this.columns);
        this.show = false;
        if (this.PersistColumnSettings) {
            if (this.UniqueKey) {
                /** @type {?} */
                var settingsPanelConfig = new SettingsPanelConfig();
                settingsPanelConfig.PersistedColumns = [
                    {
                        UniqueKey: this.UniqueKey,
                        Columns: this.columns.map((/**
                         * @param {?} c
                         * @return {?}
                         */
                        function (c) {
                            return { name: c.name, order: c.order };
                        }))
                    }
                ];
                localStorage.setItem('settings-config', JSON.stringify(settingsPanelConfig));
            }
        }
    };
    /**
     * @return {?}
     */
    SettingsComponent.prototype.toggleShow = /**
     * @return {?}
     */
    function () {
        this.show = !this.show;
    };
    /**
     * @private
     * @return {?}
     */
    SettingsComponent.prototype.checkPersistedState = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        if (localStorage.getItem('settings-config')) {
            /** @type {?} */
            var savedConfig = (/** @type {?} */ (JSON.parse(localStorage.getItem('settings-config'))));
            // order the columns the same way as the saved columns
            /** @type {?} */
            var persistedColumns_1 = savedConfig.PersistedColumns.filter((/**
             * @param {?} column
             * @return {?}
             */
            function (column) { return column.UniqueKey === _this.UniqueKey; }));
            if (persistedColumns_1.length > 0) {
                this.columns.forEach((/**
                 * @param {?} column
                 * @return {?}
                 */
                function (column) {
                    persistedColumns_1[0].Columns.forEach((/**
                     * @param {?} savedCol
                     * @return {?}
                     */
                    function (savedCol) {
                        if (column.name === savedCol.name) {
                            column.order = savedCol.order;
                        }
                    }));
                }));
                // sort column array on the order
                this.columns.sort((/**
                 * @param {?} a
                 * @param {?} b
                 * @return {?}
                 */
                function (a, b) { return a.order - b.order; }));
                // tell grid to update columns
                this.OnColumnsChanged.emit(this.columns);
            }
        }
    };
    SettingsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'settings-panel',
                    template: "<div class=\"settings-panel\" (click)=\"stopPropagation($event)\" *ngIf=\"show\" [ngClass]=\"{'animated' : show}\">\r\n    <div class=\"content\">\r\n        <h6>Arrange columns below</h6>\r\n        <p>Select the {{MinimumColumns}} columns you would like to view.</p>\r\n        <ul class=\"settings-container header \">\r\n            <li>Order</li>\r\n            <li>Column</li>\r\n            <li>Show</li>\r\n        </ul>\r\n\r\n        <div class=\"columns-container\">\r\n            <ul *ngFor=\"let column of columns, let i = index\" class=\"settings-container\"\r\n                [ngClass]=\"{'active': lastModifiedColumnIndex == i}\">\r\n                <li>\r\n                    <button class=\"btn-primary btn up\" (click)=\"moveColumnUp(column.order, i)\"\r\n                            [disabled]=\"i === 0\"></button>\r\n                    <button class=\"btn-primary btn down\" (click)=\"moveColumnDown(column.order, i)\"\r\n                            [disabled]=\"i === columns.length - 1\"></button>\r\n                </li>\r\n                <li>{{ column.name }}</li>\r\n                <li>\r\n                    <label class=\"custom-control custom-checkbox\">\r\n                        <input type=\"checkbox\" class=\"custom-control-input\" [(ngModel)]=\"column.display\">\r\n                        <span class=\"custom-control-indicator\"></span>\r\n                    </label>\r\n                </li>\r\n            </ul>\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"!validColumnCount()\" class=\"count-warning\">\r\n        <span class=\"ico-info\"></span>\r\n        Please select a total of {{MinimumColumns}} columns\r\n    </div>\r\n    <div class=\"content\">\r\n        <div class=\"button-group panel\">\r\n            <div>\r\n                <button type=\"button\" class=\"btn btn-tertiary btn-sm\" (click)=\"resetColumns()\">Reset</button>\r\n            </div>\r\n            <div>\r\n                <button type=\"button\" class=\"btn btn-secondary btn-sm\" (click)=\"cancel()\">Cancel</button>\r\n                <button type=\"button\" class=\"btn btn-primary btn-sm\" [disabled]=\"!validColumnCount()\" (click)=\"save()\">\r\n                    Save\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    styles: [".settings-panel{width:300px;position:absolute;right:15px;background:#fff;box-shadow:0 4px 16px 0 rgba(12,12,13,.3);z-index:999;border-radius:5px;text-transform:initial}.settings-panel.animated{-webkit-animation-duration:.7s;animation-duration:.7s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-name:fadeInLeft;animation-name:fadeInLeft}.settings-panel .columns-container{max-height:250px;overflow-y:auto;overflow-x:hidden}.settings-panel .content{padding:1.3em;text-align:left}.settings-panel .content h6{font-weight:500;font-size:.9rem;margin:0;padding-bottom:2px}.settings-panel .content p{font-size:.6rem;color:#000;margin-bottom:10px}.settings-panel .content .btn-group-sm>.btn,.settings-panel .content .btn-sm{line-height:28px;padding:0 16px}.settings-panel .content .panel{display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between;padding-top:0}.settings-panel .count-warning{color:red;background-color:#ff0;text-align:center;padding:8px;font-size:12px}ul.settings-container{display:-webkit-box;display:flex;flex-wrap:nowrap;-webkit-box-pack:start;justify-content:flex-start;padding:0;margin:0;list-style:none;line-height:1.5em;font-size:12px;color:#000}ul.settings-container li{padding:7px 0 0 5px;border-bottom:1px solid #ccc}ul.settings-container li button{height:22px;width:22px;background-color:#fff;border:1px solid #ccc;color:#000;text-align:center;padding:0;outline:0}ul.settings-container li button:disabled{color:#000;cursor:default}ul.settings-container li button:hover{cursor:pointer}ul.settings-container li button.up{border-radius:5px 0 0 5px}ul.settings-container li button.up::before{font-family:feather;content:'\\e934';font-size:14px}ul.settings-container li button.up.active{color:#00f}ul.settings-container li button.down{margin-left:-4px;border-radius:0 5px 5px 0}ul.settings-container li button.down::before{font-family:feather;content:'\\e931';font-size:14px}ul.settings-container li button.down.active{color:#00f}ul.settings-container li:nth-child(1){-webkit-box-flex:0;flex:0 1 20%;padding-left:5px}ul.settings-container li:nth-child(2){-webkit-box-flex:0;flex:0 1 60%;padding-top:8px}ul.settings-container li:nth-child(3){align-self:flex-end}ul.settings-container.active{color:#00f}ul.settings-container.header li{font-weight:600;color:#000;border:0;padding-right:12px}ul.settings-container.header li:nth-child(1){padding-left:14px}ul.settings-container.header li:nth-child(2){padding-left:5px}ul.settings-container .form-group{width:50px;margin-bottom:5px}ul.settings-container .form-control{border-radius:5px!important;padding:0!important;text-align:center}ul.settings-container .input-group-addon{display:none!important}@media (max-width:767.98px){.settings-panel{border:1px solid red}}"]
                }] }
    ];
    SettingsComponent.propDecorators = {
        show: [{ type: Input }],
        MinimumColumns: [{ type: Input }],
        OnColumnsChanged: [{ type: Output }],
        documentClick: [{ type: HostListener, args: ['body:click', ['$event'],] }]
    };
    return SettingsComponent;
}());
if (false) {
    /** @type {?} */
    SettingsComponent.prototype.show;
    /** @type {?} */
    SettingsComponent.prototype.MinimumColumns;
    /** @type {?} */
    SettingsComponent.prototype.OnColumnsChanged;
    /** @type {?} */
    SettingsComponent.prototype.columns;
    /** @type {?} */
    SettingsComponent.prototype.lastModifiedColumnIndex;
    /** @type {?} */
    SettingsComponent.prototype.originalColumns;
    /**
     * Unique key of the table to save the columns for
     * @type {?}
     */
    SettingsComponent.prototype.UniqueKey;
    /**
     * Indicates if we should save the settings or not
     * @type {?}
     */
    SettingsComponent.prototype.PersistColumnSettings;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/persistence-helper.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This class will help us load and persist column settings
 * to and from local storage
 */
var PersistenceHelper = /** @class */ (function () {
    function PersistenceHelper() {
    }
    /**
     * Load the stored columns for the unique key given
     * @param uniqueKey A unique key for the table to persist to. This needs to be unique over all CE's
     */
    /**
     * Load the stored columns for the unique key given
     * @param {?} orginalColumns
     * @param {?} uniqueKey A unique key for the table to persist to. This needs to be unique over all CE's
     * @return {?}
     */
    PersistenceHelper.LoadPersistedColumns = /**
     * Load the stored columns for the unique key given
     * @param {?} orginalColumns
     * @param {?} uniqueKey A unique key for the table to persist to. This needs to be unique over all CE's
     * @return {?}
     */
    function (orginalColumns, uniqueKey) {
        // if there is a persisted state, and there is actually a persisted state for this table, return it.
        // if there is a persisted state, and there is actually a persisted state for this table, return it.
        /** @type {?} */
        var columns = __spread(orginalColumns);
        /** @type {?} */
        var config = this.GetOrCreateConfig();
        // This will return an array with 1 element if found
        /** @type {?} */
        var persistedColumns = config.PersistedColumns.filter((/**
         * @param {?} f
         * @return {?}
         */
        function (f) { return f.UniqueKey == uniqueKey; }));
        if (persistedColumns.length > 0) {
            // If we found a persisted state, order the columns in the same way
            // We can't assume the columns are exactly the same, they might have changed, 
            // so we need to loop through both arrays
            columns.forEach((/**
             * @param {?} col
             * @return {?}
             */
            function (col) {
                persistedColumns[0].Columns.forEach((/**
                 * @param {?} savedCol
                 * @return {?}
                 */
                function (savedCol) {
                    // if the names match, set the order
                    if (col.prop === savedCol.prop) {
                        col.order = savedCol.order;
                        col.display = savedCol.display;
                    }
                }));
            }));
            // Now we can actually sort on this order
            columns.sort((/**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function (a, b) { return a.order - b.order; }));
            // At this stage the columns are loaded and sorted, we return the viewable columns
            return __spread(columns.filter((/**
             * @param {?} c
             * @return {?}
             */
            function (c) { return c.display; })));
        }
        else {
            // We did not find any saved columns, return the default columns to view
            return columns.filter((/**
             * @param {?} c
             * @return {?}
             */
            function (c) { return c.display; }));
        }
    };
    /**
     * @param {?} columns
     * @param {?} uniqueKey
     * @return {?}
     */
    PersistenceHelper.PersistColumnState = /**
     * @param {?} columns
     * @param {?} uniqueKey
     * @return {?}
     */
    function (columns, uniqueKey) {
        // if there is a persisted state, and there is actually a persisted state for this table, 
        // we will append to it / edit it
        // if there is a persisted state, and there is actually a persisted state for this table, 
        // we will append to it / edit it
        /** @type {?} */
        var config = this.GetOrCreateConfig();
        // This will return an array with 1 element if found
        /** @type {?} */
        var persistedColumns = config.PersistedColumns.filter((/**
         * @param {?} f
         * @return {?}
         */
        function (f) { return f.UniqueKey == uniqueKey; }));
        if (persistedColumns.length > 0) {
            // If we found a persisted state we can replace, else we add
            // we loop here, find the matched key and break out of the loop
            for (var i = 0; i < config.PersistedColumns.length; i++) {
                if (config.PersistedColumns[i].UniqueKey == uniqueKey) {
                    // reset the column order and save back
                    config.PersistedColumns[i].Columns = columns.map((/**
                     * @param {?} c
                     * @return {?}
                     */
                    function (c) { return { prop: c.prop, order: c.order, display: c.display }; }));
                    localStorage.setItem(PersistenceHelper.StorageKey, JSON.stringify(config));
                    // break out of loop and return
                    return;
                }
            }
        }
        // If we get here, we have a state, but not for this table
        config.PersistedColumns.push({
            UniqueKey: uniqueKey,
            Columns: columns.map((/**
             * @param {?} c
             * @return {?}
             */
            function (c) { return { prop: c.prop, order: c.order, display: c.display }; }))
        });
        localStorage.setItem(PersistenceHelper.StorageKey, JSON.stringify(config));
    };
    /**
     * @return {?}
     */
    PersistenceHelper.GetOrCreateConfig = /**
     * @return {?}
     */
    function () {
        if (localStorage.getItem(PersistenceHelper.StorageKey)) {
            /** @type {?} */
            var config = ((/** @type {?} */ (JSON.parse(localStorage.getItem(PersistenceHelper.StorageKey)))));
            // if the versions do not match, nuke it
            if (config.Version !== PersistenceHelper.Version) {
                localStorage.removeItem(PersistenceHelper.StorageKey);
                //save our new version, empty at this stage though
                localStorage.setItem(PersistenceHelper.StorageKey, JSON.stringify(config));
                return config;
            }
            else
                return config;
        }
        else
            return new SettingsPanelConfig(PersistenceHelper.Version);
    };
    /**
     * The current version of our persisted state
     */
    PersistenceHelper.Version = 1;
    PersistenceHelper.StorageKey = 'settings-config';
    return PersistenceHelper;
}());
if (false) {
    /**
     * The current version of our persisted state
     * @type {?}
     */
    PersistenceHelper.Version;
    /** @type {?} */
    PersistenceHelper.StorageKey;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/lunar.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LunarComponent = /** @class */ (function () {
    function LunarComponent() {
        this.actions = [];
        this.cardView = false;
        this.paging = Paging.NONE;
        this.selectable = false;
        this.settingsPanelEnabled = false;
        this.showExpandButtons = false;
        this.sortable = true;
        this.sortCustom = false;
        /**
         * Allows user to persist some settings, IF this unique
         * key is present. For example, persist column order to local storage.
         */
        this.UniqueKey = '';
        /**
         * If true, we persist the selected columns to local storage
         */
        this.PersistColumnSettings = false;
        /**
         * Allows for additional classes to be injected to the data table
         * for a bit more customization.
         */
        this.additionalCssClasses = '';
        this.sortChanged = new EventEmitter();
        this.onPageSizeChanged = new EventEmitter();
        this.onPageChanged = new EventEmitter();
        this.onRowSelectionChanged = new EventEmitter();
        this.onRowEdited = new EventEmitter();
        this.onRowsEdited = new EventEmitter();
        this.columnsInternal = [];
        this.currentSortProperty = {
            prop: '',
            direction: SortDirection.UNKNOWN
        };
        this.defaultPageSize = 10;
        this.expandableTypeInternal = ExpandableTypes.NONE;
        this.expandableTypesEnum = ExpandableTypes;
        this.hiddenColumns = [];
        this.isAllRowsExpandable = false;
        this.isAllRowsSelected = false;
        this.page = { currentPage: 1, size: 10, totalElements: 1000 };
        this.pageSizes = [10, 20, 50, 100];
        this.pagingEnum = Paging;
        this.rowsInternal = [];
        this.rowExpandedState = RowExpandStates.COLLAPSED;
        this.rowExpandStatesEnum = RowExpandStates;
        this.defaultPageSizes = [10, 20, 50, 100];
        this.pageSizeBackup = 10;
        this.isPaging = false;
        this.isOverFlowEnabled = false;
        this.originalRows = [];
        this.originalColumns = [];
    }
    Object.defineProperty(LunarComponent.prototype, "columns", {
        /**
         * This is where the columns are set to be rendered.
         * Once set, a few other settings are configured, such as
         * the original columns, filtered columns and delta columns.
         */
        set: /**
         * This is where the columns are set to be rendered.
         * Once set, a few other settings are configured, such as
         * the original columns, filtered columns and delta columns.
         * @param {?} columns
         * @return {?}
         */
        function (columns) {
            // TODO: This points to possible issue. A components should never modify its inputs.
            this.originalColumns = columns;
            this.hiddenColumns = columns.filter((/**
             * @param {?} column
             * @return {?}
             */
            function (column) { return !column.display; }));
            // set default order (order of how we received is default)
            this.originalColumns.map((/**
             * @param {?} column
             * @param {?} index
             * @return {?}
             */
            function (column, index) { return (column.order = index); }));
            if (this.PersistColumnSettings) {
                // TODO: Static state anti-pattern - Move to an injectable service.
                this.columnsInternal = PersistenceHelper.LoadPersistedColumns(this.originalColumns, this.UniqueKey);
            }
            else {
                this.columnsInternal = columns.filter((/**
                 * @param {?} column
                 * @return {?}
                 */
                function (column) { return column.display; }));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LunarComponent.prototype, "expandableType", {
        set: /**
         * @param {?} expandableType
         * @return {?}
         */
        function (expandableType) {
            this.expandableTypeInternal = expandableType;
            this.isAllRowsExpandable =
                this.expandableTypeInternal !== ExpandableTypes.NONE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LunarComponent.prototype, "intialSort", {
        set: /**
         * @param {?} sortProperty
         * @return {?}
         */
        function (sortProperty) {
            if (sortProperty) {
                this.currentSortProperty.prop = sortProperty;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LunarComponent.prototype, "overFlowColumns", {
        /**
         * If set to true, the  grid will render it's own detail section
         * with the delta columns calculated. Delta columns are colums that are not
         * displayed in the main columns of the grid. This is the publically exposed
         * property that calculates the public variables on set.
         */
        set: /**
         * If set to true, the  grid will render it's own detail section
         * with the delta columns calculated. Delta columns are colums that are not
         * displayed in the main columns of the grid. This is the publically exposed
         * property that calculates the public variables on set.
         * @param {?} enableOverflow
         * @return {?}
         */
        function (enableOverflow) {
            this.isOverFlowEnabled = enableOverflow;
            if (enableOverflow) {
                // TODO: Setting expandable type here is unexpected. What if user wants overflow columns driven by row
                this.expandableTypeInternal = ExpandableTypes.ALL;
                this.rowDetail = this.overFlowDetailTemplate;
                this.isAllRowsExpandable = true;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LunarComponent.prototype, "PageSizeOptions", {
        set: /**
         * @param {?} pageSizes
         * @return {?}
         */
        function (pageSizes) {
            this.defaultPageSizes = pageSizes;
            this.pageSizes = pageSizes;
            /** @type {?} */
            var initialPageIndex = 0;
            this.page.size = pageSizes[initialPageIndex];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LunarComponent.prototype, "rows", {
        /**
         * This is the actual rows to render by the grid.
         * Once set, a copy is made as well as some additional settings
         * are configured.
         */
        set: /**
         * This is the actual rows to render by the grid.
         * Once set, a copy is made as well as some additional settings
         * are configured.
         * @param {?} rowData
         * @return {?}
         */
        function (rowData) {
            var _this = this;
            this.rowsInternal = rowData;
            // TODO: This points to possible issue. A components should never modify its inputs.
            this.originalRows = rowData;
            if (this.rowsInternal && this.rowsInternal.length > 0) {
                this.setPageSizes(this.rowsInternal.length, true);
            }
            if (!this.isOverFlowEnabled) {
                if (this.expandableTypeInternal === ExpandableTypes.ROW_DRIVEN &&
                    this.expandOnProperty) {
                    this.isAllRowsExpandable =
                        this.rowsInternal &&
                            this.rowsInternal.filter((/**
                             * @param {?} row
                             * @return {?}
                             */
                            function (row) { return row[_this.expandOnProperty] !== undefined; })).length > 0;
                }
                else {
                    this.isAllRowsExpandable =
                        this.expandableTypeInternal === ExpandableTypes.ALL;
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LunarComponent.prototype, "total", {
        /**
         * This property is important for server-side paging. The grid needs to
         * know the entire count so that the pages can be calculated.
         */
        set: /**
         * This property is important for server-side paging. The grid needs to
         * know the entire count so that the pages can be calculated.
         * @param {?} totalItemCount
         * @return {?}
         */
        function (totalItemCount) {
            this.page.totalElements = totalItemCount;
            if (totalItemCount && totalItemCount > 0) {
                this.setPageSizes(totalItemCount);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LunarComponent.prototype, "colSpan", {
        get: /**
         * @return {?}
         */
        function () {
            return (this.columnsInternal.length +
                (this.expandableTypeInternal !== ExpandableTypes.NONE ? +1 : 0) +
                (this.selectable ? 1 : 0) +
                (this.actions && this.actions.length > 0 ? 1 : 0));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LunarComponent.prototype, "gridClass", {
        get: /**
         * @return {?}
         */
        function () {
            return this.cardView ? 'card' : 'grid';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LunarComponent.prototype, "updatedRows", {
        get: /**
         * @return {?}
         */
        function () {
            return this.rowsInternal.filter((/**
             * @param {?} row
             * @return {?}
             */
            function (row) { return row.__dirty; }));
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    LunarComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.modalLoaderTitle = 'Please be patient';
        this.modalLoaderBody = 'Data is being loaded';
        if (this.titleTemplate) {
            this.titleHostReference.createEmbeddedView(this.titleTemplate);
        }
    };
    /**
     * @return {?}
     */
    LunarComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.setPaging();
        if (this.settingsComponent) {
            this.settingsComponent.UniqueKey = this.UniqueKey;
        }
    };
    /**
     * @param {?} pageIndex
     * @return {?}
     */
    LunarComponent.prototype.changePageIndex = /**
     * @param {?} pageIndex
     * @return {?}
     */
    function (pageIndex) {
        this.page.size = this.pageSizeBackup;
        this.page.currentPage = pageIndex;
        this.onPageChanged.emit(this.page);
    };
    /**
     * @param {?} columns
     * @return {?}
     */
    LunarComponent.prototype.columnsChanged = /**
     * @param {?} columns
     * @return {?}
     */
    function (columns) {
        this.columnsInternal = columns.filter((/**
         * @param {?} column
         * @return {?}
         */
        function (column) { return column.display; }));
        this.hiddenColumns = columns.filter((/**
         * @param {?} column
         * @return {?}
         */
        function (column) { return !column.display; }));
    };
    /**
     * @param {?} editedRow
     * @return {?}
     */
    LunarComponent.prototype.dataChanged = /**
     * @param {?} editedRow
     * @return {?}
     */
    function (editedRow) {
        this.onRowEdited.emit(editedRow);
        this.onRowsEdited.emit(this.updatedRows);
    };
    /**
     * @return {?}
     */
    LunarComponent.prototype.getSelectedRows = /**
     * @return {?}
     */
    function () {
        return this.rowsInternal.filter((/**
         * @param {?} row
         * @return {?}
         */
        function (row) {
            return row.__selected;
        }));
    };
    /**
     * @param {?} action
     * @param {?} row
     * @return {?}
     */
    LunarComponent.prototype.handleAction = /**
     * @param {?} action
     * @param {?} row
     * @return {?}
     */
    function (action, row) {
        if (action.command) {
            action.command(row);
        }
    };
    /**
     * @param {?} action
     * @param {?} row
     * @return {?}
     */
    LunarComponent.prototype.handleActionCondition = /**
     * @param {?} action
     * @param {?} row
     * @return {?}
     */
    function (action, row) {
        if (action.condition) {
            return action.condition(row);
        }
        else {
            return true;
        }
    };
    /**
     * @return {?}
     */
    LunarComponent.prototype.pageSizeChanged = /**
     * @return {?}
     */
    function () {
        this.page.currentPage = 1;
        this.defaultPageSize = this.page.size;
        this.onPageSizeChanged.emit(this.page);
    };
    /**
     * @param {?} column
     * @return {?}
     */
    LunarComponent.prototype.resolveSortIcon = /**
     * @param {?} column
     * @return {?}
     */
    function (column) {
        if (this.currentSortProperty.prop === '' ||
            this.currentSortProperty.prop !== column.prop) {
            return 'ico-sort';
        }
        if (this.currentSortProperty.direction === SortDirection.ASC) {
            return 'ico-sort-up';
        }
        return 'ico-sort-down';
    };
    /**
     * @param {?} column
     * @return {?}
     */
    LunarComponent.prototype.resolveTextAlignment = /**
     * @param {?} column
     * @return {?}
     */
    function (column) {
        switch (column.alignment) {
            case ColumnAlignment.CENTER:
                return 'text-center';
            case ColumnAlignment.RIGHT:
                return 'text-right';
            default:
                return 'text-left';
        }
    };
    /**
     * @return {?}
     */
    LunarComponent.prototype.rowSelectionChanged = /**
     * @return {?}
     */
    function () {
        this.onRowSelectionChanged.emit({
            rows: this.getSelectedRows(),
            pageSize: this.page.size
        });
    };
    /**
     * @return {?}
     */
    LunarComponent.prototype.setCheckedRows = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.rowsInternal.map((/**
         * @param {?} row
         * @return {?}
         */
        function (row) { return (row.__selected = _this.isAllRowsSelected); }));
        this.rowSelectionChanged();
    };
    /**
     * @param {?} state
     * @return {?}
     */
    LunarComponent.prototype.setExpandedState = /**
     * @param {?} state
     * @return {?}
     */
    function (state) {
        this.rowExpandedState = state;
        if (this.expandableTypeInternal === ExpandableTypes.ALL) {
            this.toggleAll();
        }
        else if (this.expandableTypeInternal === ExpandableTypes.ROW_DRIVEN) {
            this.toggleRowEnabled();
        }
    };
    /**
     * @param {?} pageSize
     * @param {?=} setPageSize
     * @return {?}
     */
    LunarComponent.prototype.setPageSizes = /**
     * @param {?} pageSize
     * @param {?=} setPageSize
     * @return {?}
     */
    function (pageSize, setPageSize) {
        if (setPageSize === void 0) { setPageSize = false; }
        /** @type {?} */
        var options = [];
        if (this.defaultPageSizes.findIndex((/**
         * @param {?} defaultPageSize
         * @return {?}
         */
        function (defaultPageSize) { return defaultPageSize === pageSize; })) === -1 &&
            setPageSize) {
            options = __spread(this.defaultPageSizes);
            options.push(pageSize);
            this.pageSizeBackup = this.page.size;
            this.page.size = pageSize;
        }
        else {
            options = __spread(this.defaultPageSizes);
        }
        options.sort((/**
         * @param {?} a
         * @param {?} b
         * @return {?}
         */
        function (a, b) { return a - b; }));
        this.pageSizes = options;
    };
    /**
     * @param {?} isSelected
     * @return {?}
     */
    LunarComponent.prototype.setRowSelection = /**
     * @param {?} isSelected
     * @return {?}
     */
    function (isSelected) {
        this.isAllRowsSelected = isSelected;
        this.rowsInternal.map((/**
         * @param {?} row
         * @return {?}
         */
        function (row) { return (row.__selected = isSelected); }));
        this.onRowSelectionChanged.emit({
            rows: this.getSelectedRows(),
            pageSize: this.page.size
        });
    };
    /**
     * @param {?} row
     * @return {?}
     */
    LunarComponent.prototype.showExpandButton = /**
     * @param {?} row
     * @return {?}
     */
    function (row) {
        switch (this.expandableTypeInternal) {
            case ExpandableTypes.NONE:
                return false;
            case ExpandableTypes.ALL:
                return true;
            case ExpandableTypes.ROW_DRIVEN:
                return row[this.expandOnProperty] == null
                    ? false
                    : row[this.expandOnProperty];
        }
    };
    /**
     * @param {?} sortProperty
     * @return {?}
     */
    LunarComponent.prototype.sortRows = /**
     * @param {?} sortProperty
     * @return {?}
     */
    function (sortProperty) {
        if (!this.sortable)
            return;
        if (this.currentSortProperty.direction === SortDirection.UNKNOWN) {
            this.currentSortProperty.direction = SortDirection.ASC;
        }
        if (sortProperty === this.currentSortProperty.prop) {
            this.currentSortProperty.direction *= -1;
        }
        else {
            this.currentSortProperty.prop = sortProperty;
            this.currentSortProperty.direction = SortDirection.ASC;
        }
        this.sortChanged.emit(sortProperty);
        if (this.sortCustom)
            return;
        // need to reset before sorting
        // behaviour would be a combination of sorting that is not expected
        this.rowsInternal = __spread(this.originalRows);
        if (this.currentSortProperty.direction === SortDirection.ASC) {
            this.rowsInternal = this.rowsInternal.sort((/**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function (a, b) {
                return a[sortProperty]
                    .toString()
                    .localeCompare(b[sortProperty].toString(), undefined, {
                    numeric: true
                });
            }));
        }
        else if (this.currentSortProperty.direction === SortDirection.DESC) {
            this.rowsInternal = this.rowsInternal.sort((/**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function (a, b) {
                return b[sortProperty]
                    .toString()
                    .localeCompare(a[sortProperty].toString(), undefined, {
                    numeric: true
                });
            }));
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LunarComponent.prototype.toggleSettingsPanel = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        event.stopPropagation();
        this.settingsComponent.toggleShow();
        this.settingsComponent.setColumns(this.originalColumns);
    };
    /**
     * @param {?} row
     * @return {?}
     */
    LunarComponent.prototype.toggleRowExpandState = /**
     * @param {?} row
     * @return {?}
     */
    function (row) {
        row.__expanded = !row.__expanded && this.showExpandButton(row);
        /** @type {?} */
        var expanded = this.rowsInternal.filter((/**
         * @param {?} r
         * @return {?}
         */
        function (r) { return r.__expanded; })).length;
        this.rowExpandedState =
            expanded === 0
                ? RowExpandStates.COLLAPSED
                : expanded === this.page.size
                    ? RowExpandStates.EXPANDED
                    : RowExpandStates.PARTIAL;
    };
    /**
     * @param {?=} index
     * @return {?}
     */
    LunarComponent.prototype.onPagination = /**
     * @param {?=} index
     * @return {?}
     */
    function (index) {
        this.page.currentPage = index;
        this.onPageChanged.emit(this.page);
    };
    /**
     * @private
     * @return {?}
     */
    LunarComponent.prototype.setPaging = /**
     * @private
     * @return {?}
     */
    function () {
        if (this.paging === Paging.PAGED && this.rowsInternal) {
            this.isPaging = true;
        }
        else if (this.paging === Paging.NONE) {
            this.isPaging = false;
        }
        else {
            this.isPaging =
                this.rowsInternal &&
                    this.rowsInternal.length > this.pageSizes[0];
        }
    };
    /**
     * @private
     * @return {?}
     */
    LunarComponent.prototype.toggleAll = /**
     * @private
     * @return {?}
     */
    function () {
        if (this.rowExpandedState === RowExpandStates.EXPANDED) {
            this.rowsInternal.forEach((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return (x.__expanded = true); }));
        }
        else if (this.rowExpandedState === RowExpandStates.COLLAPSED) {
            this.rowsInternal.forEach((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return (x.__expanded = false); }));
        }
    };
    /**
     * @private
     * @return {?}
     */
    LunarComponent.prototype.toggleRowEnabled = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.rowsInternal.forEach((/**
         * @param {?} row
         * @return {?}
         */
        function (row) {
            if (_this.rowExpandedState === RowExpandStates.EXPANDED) {
                /** @type {?} */
                var hasProperty = {}.hasOwnProperty.call(row, _this.expandOnProperty);
                if (hasProperty) {
                    row.__expanded = row[_this.expandOnProperty];
                }
            }
            else if (_this.rowExpandedState === RowExpandStates.COLLAPSED) {
                row.__expanded = false;
            }
        }));
    };
    LunarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'solar-lunar',
                    template: "<div class=\"row no-gutter mb-4\">\r\n    <div class=\"col-9\">\r\n        <ng-container #titleHost></ng-container>\r\n    </div>\r\n    <div class=\"col-3 text-right\">\r\n        <div class=\"segmented-control\" *ngIf=\"expandableTypeInternal !== expandableTypesEnum.NONE && showExpandButtons\">\r\n            <div class=\"btn-group\">\r\n                <button [disabled]=\"loading\" class=\"btn btn-secondary\" (click)=\"setExpandedState(rowExpandStatesEnum.EXPANDED)\"\r\n                    [ngClass]=\"{'selected' : rowExpandedState === rowExpandStatesEnum.EXPANDED}\">Expand all</button>\r\n                <button [disabled]=\"loading\" class=\"btn btn-secondary\" (click)=\"setExpandedState(rowExpandStatesEnum.COLLAPSED)\"\r\n                    [ngClass]=\"{'selected' : rowExpandedState === rowExpandStatesEnum.COLLAPSED}\">Collapse all</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"container-fluid p-0 lunar mt-2\" [ngClass]=\"{'loading' : loading}\">\r\n    <div class=\"row\">\r\n        <div class=\"col\">\r\n            <table class=\"{{gridClass}}-table {{additionalCssClasses}}\" [ngClass]=\"{ 'horizontal-scroll' : horizontalScroll }\">\r\n                <thead>\r\n                    <tr class=\"{{gridClass}}-table-header-row\">\r\n                        <th class=\"{{gridClass}}-table-column-header checkbox-column\" *ngIf=\"selectable\">\r\n                            <label class=\"custom-control custom-checkbox\">\r\n                                <input type=\"checkbox\" class=\"custom-control-input\" [(ngModel)]=\"isAllRowsSelected\"\r\n                                    (change)=\"setCheckedRows()\">\r\n                                <span class=\"custom-control-indicator\"></span>\r\n                            </label>\r\n                        </th>\r\n                        <th *ngFor=\"let column of columnsInternal\" class=\"{{gridClass}}-table-column-header {{resolveTextAlignment(column)}} {{column.class}}\"\r\n                            [ngClass]=\"{'sorting' : currentSortProperty.prop == column.prop && sortable}\"\r\n                            (click)=\"sortRows(column.prop)\">\r\n                            <span class=\"{{gridClass}}-header-label\">\r\n                                <ng-container\r\n                                    *ngTemplateOutlet=\"column.headerTemplate || defaultHeaderTemplate;context : {column : column}\">\r\n                                </ng-container> \r\n                            </span>\r\n                            <i class=\"sort-space\" *ngIf=\"sortable\"></i>\r\n                            <i class=\"{{resolveSortIcon(column)}}\" *ngIf=\"sortable\"></i>\r\n                        </th>\r\n                        \r\n                        <th class=\"{{gridClass}}-table-column-header actions\" *ngIf=\"actions?.length > 0\"></th>\r\n\r\n                        <th class=\"{{gridClass}}-table-column-header expand\" [hidden]=\"rowsInternal.length === 0\"\r\n                            *ngIf=\"isAllRowsExpandable || settingsPanelEnabled\">\r\n                            <i class=\"icon icon-configure-settings\" *ngIf=\"settingsPanelEnabled\" (click)=\"toggleSettingsPanel($event)\"></i>\r\n                            <settings-panel (OnColumnsChanged)=\"columnsChanged($event)\" [MinimumColumns]=\"8\"></settings-panel>\r\n                        </th>\r\n                    </tr>\r\n                </thead>\r\n                <tbody>\r\n                    <ng-container *ngFor=\"let row of rowsInternal;let i = index\">\r\n                        <tr class=\"{{gridClass}}-table-data-row\" [ngClass]=\"{'row-expanded' : row.__expanded}\">\r\n                            <td class=\"{{gridClass}}-table-cell checkbox-column\" *ngIf=\"selectable\">\r\n\r\n                                <label class=\"custom-control custom-checkbox\">\r\n                                    <input type=\"checkbox\" class=\"custom-control-input\" [(ngModel)]=\"row.__selected\" (change)=\"rowSelectionChanged()\">\r\n                                    <span class=\"custom-control-indicator\"></span>\r\n                                </label>\r\n\r\n                            </td>\r\n                            <td *ngFor=\"let column of columnsInternal\" class=\"{{gridClass}}-table-cell {{resolveTextAlignment(column)}} {{column.class}}\">\r\n                                \r\n                                <ng-container *ngIf=\"column.editable\">\r\n                                        <input type=\"text\" [(ngModel)]=\"row[column.prop]\" (change)=\"row.__dirty = true\" (blur)=\"dataChanged(row)\">\r\n                                </ng-container>\r\n                                         \r\n                                <ng-container *ngIf=\"!column.editable\">\r\n                                    <ng-container \r\n                                        *ngTemplateOutlet=\"column.cellTemplate || cell; context : {row : row, column : column, value : row[column.prop]}\">\r\n                                    </ng-container>\r\n\r\n                                </ng-container>\r\n                                \r\n                            </td>\r\n\r\n                            <td *ngIf=\"actions?.length > 0 && !actionsCondition(row)\" class=\"{{gridClass}}-table-cell actions\">\r\n                                <div class=\"actions-btn-wrapper\">\r\n                                    <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\r\n                                        <defs><path id=\"a\" d=\"M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z\"/></defs>\r\n                                        <g fill=\"none\" fill-rule=\"evenodd\">\r\n                                            <path d=\"M0 0h24v24H0z\"/>\r\n                                            <mask id=\"b\" fill=\"#fff\"><use xlink:href=\"#a\"/></mask>\r\n                                            <g fill=\"#ccc\" mask=\"url(#b)\"><path d=\"M0 0h24v24H0z\"/></g>\r\n                                        </g>\r\n                                    </svg>\r\n                                </div> \r\n                            </td>\r\n\r\n                            <td *ngIf=\"actions?.length > 0 && actionsCondition(row)\" class=\"{{gridClass}}-table-cell actions\" (mouseleave)=\"row.__showActions = false\">\r\n\r\n                                <div class=\"actions-btn-wrapper actions-btn-wrapper--enabled\" (click)=\"row.__showActions = !row.__showActions\" >\r\n                                    <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\r\n                                        <defs><path id=\"a\" d=\"M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z\"/></defs>\r\n                                        <g fill=\"none\" fill-rule=\"evenodd\">\r\n                                            <path d=\"M0 0h24v24H0z\"/>\r\n                                            <mask id=\"b\" fill=\"#fff\"><use xlink:href=\"#a\"/></mask>\r\n                                            <g fill=\"#555\" mask=\"url(#b)\"><path d=\"M0 0h24v24H0z\"/></g>\r\n                                        </g>\r\n                                    </svg>\r\n                                </div>\r\n                                \r\n                                <div *ngIf=\"row.__showActions\" class=\"row-actions\">\r\n                                    \r\n                                    <ng-container *ngFor=\"let a of actions\" >\r\n\r\n                                    <div  *ngIf=\"handleActionCondition(a,row)\">\r\n                                        <div class=\"action-item\" (click)=\"handleAction(a,row)\">                                                                                \r\n                                            <span class=\"icon\" [ngClass]=\"'ico-' + a.icon\"></span>                                             \r\n                                            <span class=\"item\">{{a.title}}</span>                                        \r\n                                        </div>                                    \r\n                                    </div>\r\n\r\n                                    </ng-container>\r\n\r\n                                </div>\r\n \r\n                            </td>\r\n\r\n                            <td class=\"{{gridClass}}-table-cell expand\" [ngClass]=\"{'pointer' : showExpandButton(row)}\"\r\n                                *ngIf=\"isAllRowsExpandable || settingsPanelEnabled\" (click)=\"toggleRowExpandState(row)\">\r\n                                <ng-container *ngIf=\"showExpandButton(row)\">\r\n                                    <i *ngIf=\"!row.__expanded\" class=\"lunar-expanded-icon-down\"></i>\r\n                                    <i *ngIf=\"row.__expanded\" class=\"lunar-expanded-icon-up\"></i>\r\n                                </ng-container>\r\n                            </td>\r\n                        </tr>\r\n                        <tr *ngIf=\"row.__expanded\" class=\"{{gridClass}}-table-detail-row\">\r\n                            <td class=\"{{gridClass}}-table-detail-cell \" attr.colspan=\"{{colSpan}}\">\r\n                                <ng-container\r\n                                    *ngTemplateOutlet=\"rowDetailHeader || blankTemplate; context : {row : row}\">\r\n                                </ng-container>\r\n                                <div>\r\n                                    <ng-container *ngTemplateOutlet=\"rowDetail || blankTemplate; context : {row : row}\">\r\n                                    </ng-container>\r\n                                </div>\r\n                                <ng-container\r\n                                    *ngTemplateOutlet=\"rowDetailFooter || blankTemplate; context : {row : row}\">\r\n                                </ng-container>\r\n                            </td>\r\n                        </tr>\r\n                    </ng-container>\r\n                </tbody>\r\n            </table>\r\n\r\n            <div *ngIf=\"rowsInternal.length === 0 && !loading\" class=\"page-information\">\r\n                <svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n                    <defs><path d=\"M14.6888818,1.5662552 L23.5700389,16.9188198 C23.8499007,17.4191755 23.9945484,17.9716291 24,18.5284241 C24.0197045,20.3203706 22.6256364,21.7975598 20.8909126,21.8181818 L3.12335747,21.8181818 C2.57306743,21.8116696 2.04164448,21.6608031 1.57415999,21.3818629 C0.846728971,20.9466294 0.325787736,20.2454801 0.108816235,19.404318 C-0.109203437,18.5642413 0.00295091339,17.687262 0.422219514,16.9340149 L9.31071384,1.57168205 C9.57485306,1.12016796 9.93961674,0.74137368 10.3704152,0.471116446 C11.8514816,-0.460131373 13.7905988,0.0326267969 14.6888818,1.5662552 Z M10.935,15.7383944 C10.65,16.0251868 10.5,16.4161302 10.5,16.8100925 C10.5,17.0063189 10.53,17.2025453 10.6035,17.3836774 C10.68,17.5648095 10.8,17.7293378 10.935,17.8817906 C11.22,18.1670736 11.595,18.3195264 12,18.3195264 C12.405,18.3195264 12.78,18.1670736 13.065,17.8817906 C13.2,17.7293378 13.305,17.5648095 13.38,17.3836774 C13.455,17.2025453 13.5,17.0063189 13.5,16.8100925 C13.5,16.4161302 13.335,16.0251868 13.065,15.7383944 C12.51,15.1799038 11.49,15.1799038 10.935,15.7383944 Z M12,5.45454545 C11.1705,5.45454545 10.5,6.02803571 10.5,6.73465763 L10.5,11.8551063 C10.5,12.5630083 11.1705,13.1352185 12,13.1352185 C12.8295,13.1352185 13.5,12.5630083 13.5,11.8551063 L13.5,6.73465763 C13.5,6.02803571 12.8295,5.45454545 12,5.45454545 Z\" id=\"path-1\"></path></defs>\r\n                    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><mask id=\"mask-2\" fill=\"white\"><use xlink:href=\"#path-1\"></use></mask><use id=\"Warning\" fill=\"#F28F06\" xlink:href=\"#path-1\"></use></g>\r\n                </svg>\r\n                <p>{{ noDataMessage }}</p>\r\n            </div>\r\n\r\n        </div>\r\n    </div>\r\n    <div class=\"row pager-container\" *ngIf=\"paging !== pagingEnum.NONE && rowsInternal?.length > 0\">\r\n        \r\n        <div class=\"col page-size\">\r\n            <span>Showing</span>\r\n            <select class=\"page-size-selector\" name=\"size\" [(ngModel)]=\"this.page.size\" (change)=\"pageSizeChanged()\">\r\n                <option [value]=\"opt\" *ngFor=\"let opt of pageSizes\">{{opt}}</option>\r\n            </select>        \r\n            <span>\r\n                of {{page.totalElements}} records\r\n            </span>\r\n            {{page.totalElements}} records\r\n        </div> \r\n        <div class=\"col\">          \r\n            <lunar-pagination\r\n                [count]=\"page.totalElements\"\r\n                [page]=\"page.currentPage\"\r\n                [perPage]=\"defaultPageSize\"\r\n                [pagesToShow]=\"page.totalElements\"\r\n                [loading]=\"false\"\r\n                (goPage)=\"onPagination($event)\"\r\n                (onPrev)=\"onPagination($event)\"\r\n                (onNext)=\"onPagination($event)\"\r\n                (onPage)=\"onPagination($event)\">\r\n            </lunar-pagination>            \r\n        </div>\r\n    </div>\r\n</div> \r\n\r\n\r\n<ng-template #defaultHeaderTemplate let-column=\"column\">\r\n    {{column.name}}\r\n</ng-template>\r\n\r\n<ng-template #cell let-row=\"row\" let-column=\"column\">\r\n    {{row[column.prop]}}\r\n</ng-template>\r\n\r\n<ng-template #overflowcell let-row=\"row\" let-column=\"column\">\r\n    <p> {{row[column.prop]}}</p>\r\n</ng-template>\r\n\r\n\r\n<!--default detail if someone specifies detail true, but does not provide template-->\r\n<ng-template #blankTemplate let-row=\"row\">\r\n\r\n</ng-template>\r\n\r\n<!--dynamically creates to overflow properties that are not selected in the settings-->\r\n<ng-template #overflow let-row=\"row\">\r\n    <div class=\"row overflow-detail\">\r\n\r\n        <div class=\"col-3 overflow-cell\" *ngFor=\"let column of hiddenColumns\">\r\n            <span>\r\n                {{column.name}}\r\n            </span>\r\n\r\n            <ng-container\r\n                *ngTemplateOutlet=\"column.overflowTemplate || overflowcell; context : {row : row, column : column, value : row[column.prop]}\">\r\n            </ng-container>\r\n\r\n        </div>\r\n\r\n    </div>\r\n</ng-template>\r\n",
                    encapsulation: ViewEncapsulation.Emulated,
                    styles: [".custom-control{position:relative;display:block;min-height:1.5rem;padding-left:1.5rem}.custom-control-inline{display:-webkit-inline-box;display:inline-flex;margin-right:1rem}.custom-control-input{position:absolute;z-index:-1;opacity:0}.custom-control-input:checked~.custom-control-label::before{color:#fff;border-color:#007bff;background-color:#007bff}.custom-control-input:focus~.custom-control-label::before{box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-control-input:focus:not(:checked)~.custom-control-label::before{border-color:#80bdff}.custom-control-input:not(:disabled):active~.custom-control-label::before{color:#fff;background-color:#b3d7ff;border-color:#b3d7ff}.custom-control-input:disabled~.custom-control-label{color:#6c757d}.custom-control-input:disabled~.custom-control-label::before{background-color:#e9ecef}.custom-control-label{position:relative;margin-bottom:0;vertical-align:top}.custom-control-label::before{position:absolute;top:.25rem;left:-1.5rem;display:block;width:1rem;height:1rem;pointer-events:none;content:\"\";background-color:#fff;border:1px solid #adb5bd}.custom-control-label::after{position:absolute;top:.25rem;left:-1.5rem;display:block;width:1rem;height:1rem;content:\"\";background:50%/50% 50% no-repeat}.custom-checkbox .custom-control-label::before{border-radius:.25rem}.custom-checkbox .custom-control-input:checked~.custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e\")}.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::before{border-color:#007bff;background-color:#007bff}.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3e%3cpath stroke='%23fff' d='M0 2h4'/%3e%3c/svg%3e\")}.custom-checkbox .custom-control-input:disabled:checked~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-checkbox .custom-control-input:disabled:indeterminate~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-radio .custom-control-label::before{border-radius:50%}.custom-radio .custom-control-input:checked~.custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\")}.custom-radio .custom-control-input:disabled:checked~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-switch{padding-left:2.25rem}.custom-switch .custom-control-label::before{left:-2.25rem;width:1.75rem;pointer-events:all;border-radius:.5rem}.custom-switch .custom-control-label::after{top:calc(.25rem + 2px);left:calc(-2.25rem + 2px);width:calc(1rem - 4px);height:calc(1rem - 4px);background-color:#adb5bd;border-radius:.5rem;-webkit-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-transform .15s ease-in-out;transition:transform .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-transform .15s ease-in-out}@media (prefers-reduced-motion:reduce){.custom-switch .custom-control-label::after{-webkit-transition:none;transition:none}}.custom-switch .custom-control-input:checked~.custom-control-label::after{background-color:#fff;-webkit-transform:translateX(.75rem);transform:translateX(.75rem)}.custom-switch .custom-control-input:disabled:checked~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-select{display:inline-block;width:100%;height:calc(1.5em + .75rem + 2px);padding:.375rem 1.75rem .375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;vertical-align:middle;background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right .75rem center/8px 10px no-repeat #fff;border:1px solid #ced4da;border-radius:.25rem;-webkit-appearance:none;-moz-appearance:none;appearance:none}.custom-select:focus{border-color:#80bdff;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-select:focus::-ms-value{color:#495057;background-color:#fff}.custom-select[multiple],.custom-select[size]:not([size=\"1\"]){height:auto;padding-right:.75rem;background-image:none}.custom-select:disabled{color:#6c757d;background-color:#e9ecef}.custom-select::-ms-expand{display:none}.custom-select-sm{height:calc(1.5em + .5rem + 2px);padding-top:.25rem;padding-bottom:.25rem;padding-left:.5rem;font-size:.875rem}.custom-select-lg{height:calc(1.5em + 1rem + 2px);padding-top:.5rem;padding-bottom:.5rem;padding-left:1rem;font-size:1.25rem}.custom-file{position:relative;display:inline-block;width:100%;height:calc(1.5em + .75rem + 2px);margin-bottom:0}.custom-file-input{position:relative;z-index:2;width:100%;height:calc(1.5em + .75rem + 2px);margin:0;opacity:0}.custom-file-input:focus~.custom-file-label{border-color:#80bdff;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-file-input:disabled~.custom-file-label{background-color:#e9ecef}.custom-file-input:lang(en)~.custom-file-label::after{content:\"Browse\"}.custom-file-input~.custom-file-label[data-browse]::after{content:attr(data-browse)}.custom-file-label{position:absolute;top:0;right:0;left:0;z-index:1;height:calc(1.5em + .75rem + 2px);padding:.375rem .75rem;font-weight:400;line-height:1.5;color:#495057;background-color:#fff;border:1px solid #ced4da;border-radius:.25rem}.custom-file-label::after{position:absolute;top:0;right:0;bottom:0;z-index:3;display:block;height:calc(1.5em + .75rem);padding:.375rem .75rem;line-height:1.5;color:#495057;content:\"Browse\";background-color:#e9ecef;border-left:inherit;border-radius:0 .25rem .25rem 0}.custom-range{width:100%;height:calc(1rem + .4rem);padding:0;background-color:transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none}.custom-range:focus{outline:0}.custom-range:focus::-webkit-slider-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-range:focus::-moz-range-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-range:focus::-ms-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-range::-moz-focus-outer{border:0}.custom-range::-webkit-slider-thumb{width:1rem;height:1rem;margin-top:-.25rem;background-color:#007bff;border:0;border-radius:1rem;-webkit-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.custom-range::-webkit-slider-thumb{-webkit-transition:none;transition:none}}.custom-range::-webkit-slider-thumb:active{background-color:#b3d7ff}.custom-range::-webkit-slider-runnable-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.custom-range::-moz-range-thumb{width:1rem;height:1rem;background-color:#007bff;border:0;border-radius:1rem;-webkit-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.custom-range::-moz-range-thumb{-webkit-transition:none;transition:none}}.custom-range::-moz-range-thumb:active{background-color:#b3d7ff}.custom-range::-moz-range-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.custom-range::-ms-thumb{width:1rem;height:1rem;margin-top:0;margin-right:.2rem;margin-left:.2rem;background-color:#007bff;border:0;border-radius:1rem;-webkit-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;appearance:none}@media (prefers-reduced-motion:reduce){.custom-range::-ms-thumb{-webkit-transition:none;transition:none}}.custom-range::-ms-thumb:active{background-color:#b3d7ff}.custom-range::-ms-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:transparent;border-color:transparent;border-width:.5rem}.custom-range::-ms-fill-lower{background-color:#dee2e6;border-radius:1rem}.custom-range::-ms-fill-upper{margin-right:15px;background-color:#dee2e6;border-radius:1rem}.custom-range:disabled::-webkit-slider-thumb{background-color:#adb5bd}.custom-range:disabled::-webkit-slider-runnable-track{cursor:default}.custom-range:disabled::-moz-range-thumb{background-color:#adb5bd}.custom-range:disabled::-moz-range-track{cursor:default}.custom-range:disabled::-ms-thumb{background-color:#adb5bd}.custom-control-label::before,.custom-file-label,.custom-select{-webkit-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.custom-control-label::before,.custom-file-label,.custom-select{-webkit-transition:none;transition:none}}::ng-deep .custom-control{display:-webkit-inline-box!important;display:inline-flex!important}::ng-deep .custom-control .custom-control-indicator{position:unset}:host{display:block}:host::ng-deep .solar-error-field{color:var(--error);font-size:14px}:host::ng-deep input{position:absolute;z-index:-1;opacity:0}:host::ng-deep .custom-control.custom-checkbox{padding-left:0;margin:0;cursor:pointer}:host::ng-deep .custom-control.custom-checkbox input:not([disabled]):hover~.custom-control-indicator{border:2px solid var(--branding-secondary)}:host::ng-deep .custom-control.custom-checkbox input:not([disabled])[checked=true]:hover~.custom-control-indicator{border:2px solid var(--branding-secondary)}:host::ng-deep .custom-control.custom-checkbox .custom-control-indicator{height:18px;width:18px;border:2px solid var(--body-color);border-radius:2px;margin-right:5px;-webkit-transition:background-color 250ms cubic-bezier(.4,0,.23,1),border-color 250ms;transition:background-color 250ms cubic-bezier(.4,0,.23,1),border-color 250ms}:host::ng-deep .custom-control.custom-checkbox .custom-control-indicator.focus,:host::ng-deep .custom-control.custom-checkbox .custom-control-indicator:focus{box-shadow:var(--shadow);outline:0}:host::ng-deep .custom-control.custom-checkbox input:checked[disabled]~.custom-control-indicator{background-image:none;border:2px solid var(--disabled);background-color:var(--disabled)}:host::ng-deep .custom-control.custom-checkbox input:checked[disabled]~.custom-control-indicator::before{position:absolute;font-family:feather;content:'\\e92e';display:block;color:#fff;font-size:15px;line-height:1}:host::ng-deep .custom-control.custom-checkbox input:checked~.custom-control-indicator{background-image:none;border:2px solid var(--branding-secondary);background-color:var(--branding-secondary);-webkit-animation:.3s cubic-bezier(.4,0,.23,1) checkbox-shrink-bounce-animation;animation:.3s cubic-bezier(.4,0,.23,1) checkbox-shrink-bounce-animation}:host::ng-deep .custom-control.custom-checkbox input:checked~.custom-control-indicator::before{position:absolute;font-family:feather;content:'\\e92e';display:block;color:#fff;font-size:15px;line-height:1}:host::ng-deep .custom-control.custom-checkbox input[checked=true]~.custom-control-indicator{background-image:none;border:2px solid var(--branding-secondary);background-color:var(--branding-secondary)}:host::ng-deep .custom-control.custom-checkbox input[checked=true]~.custom-control-indicator::before{font-family:feather;content:'\\e92e';display:block;color:#fff;font-size:15px;line-height:1}:host::ng-deep .custom-control.custom-checkbox .custom-control-description{line-height:1.05;font-weight:400;position:relative;z-index:0}:host::ng-deep .custom-control.custom-checkbox .custom-control-description label{position:relative;z-index:-1}:host::ng-deep .custom-control.custom-checkbox input:disabled~.custom-control-indicator{border:2px solid var(--disabled);background-color:transparent}:host::ng-deep .custom-control.custom-checkbox input:disabled~.custom-control-description{color:var(--form-color)}:host::ng-deep .custom-control.custom-checkbox input[checked=true]:disabled~.custom-control-indicator{border:2px solid var(--disabled);background-color:var(--disabled)}@-webkit-keyframes checkbox-shrink-bounce-animation{0%{-webkit-transform:scale(1.1);transform:scale(1.1)}33%{-webkit-transform:scale(.8);transform:scale(.8)}100%{-webkit-transform:scale(1);transform:scale(1)}}@keyframes checkbox-shrink-bounce-animation{0%{-webkit-transform:scale(1.1);transform:scale(1.1)}33%{-webkit-transform:scale(.8);transform:scale(.8)}100%{-webkit-transform:scale(1);transform:scale(1)}}:host::ng-deep.lunar-status{position:relative;border-radius:20px;width:100%;display:block;text-align:left;padding-left:25px}:host::ng-deep.lunar-status.success:before{background:#3bb719}:host::ng-deep.lunar-status.danger:before{background:#f60e08}:host::ng-deep.lunar-status.info:before{background:#099ef3}:host::ng-deep.lunar-status:before{content:' ';width:15px;height:15px;position:absolute;border-radius:50%;left:0;top:4px}.lunar{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.lunar.loading{opacity:.5;pointer-events:none}.lunar .checkbox-column{max-width:65px;min-width:65px;width:65px}.lunar .overflow-detail{padding:20px}.lunar .icon-gear{display:inline-block!important}.lunar .icon-gear::before{font-family:feather;content:\"\\e9b9\";font-style:normal;color:#000;font-size:1.2rem;cursor:pointer;font-weight:400}.lunar .row-actions{border-radius:4px;position:absolute;background:#fff;min-width:210px;box-shadow:0 4px 12px 0 rgba(47,47,47,.2);z-index:10;right:5px;top:50px;-webkit-animation:.2s cubic-bezier(.25,.46,.45,.94) both scale-in-ver-top;animation:.2s cubic-bezier(.25,.46,.45,.94) both scale-in-ver-top}.lunar .row-actions .action-item{padding:12px 60px 12px 16px;white-space:nowrap;width:auto}.lunar .row-actions .action-item .item{color:#2d2323}.lunar .row-actions .action-item:hover{cursor:pointer;background:#f7f7f9}.lunar .row-actions .action-item .icon{float:left;margin-right:10px}.lunar ngb-pagination li:not(:last-of-type){margin-right:10px}.lunar ngb-pagination li a{border-radius:3px!important;min-width:32px;max-width:32px;min-height:32px;max-height:32px;line-height:16px;text-align:center}.lunar ngb-pagination li a:before{color:#000}.lunar ngb-pagination li a.page-link{position:relative;display:block;margin-left:-1px;line-height:30px;text-align:center;font-size:.8rem;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;padding:0}.lunar ngb-pagination li.disabled a:before{color:#e4e4e4;cursor:not-allowed}.lunar ngb-pagination li:nth-child(1) a span{display:none}.lunar ngb-pagination li:nth-child(1) a:before{font-family:feather;content:\"\\e936\"}.lunar ngb-pagination li:nth-child(2) a span{display:none}.lunar ngb-pagination li:nth-child(2) a:before{font-family:feather;content:\"\\e932\"}.lunar ngb-pagination li:nth-last-child(2) a span{display:none}.lunar ngb-pagination li:nth-last-child(2) a:before{font-family:feather;content:\"\\e933\"}.lunar ngb-pagination li:last-child a span{display:none}.lunar ngb-pagination li:last-child a:before{font-family:feather;content:\"\\e937\"}.lunar .page-size{font-size:.8rem}.lunar .page-size sol-select{margin-left:8px}.lunar .page-size *{display:inline;line-height:20px}.lunar .page-size select{max-width:60px;height:30px;display:inline-block!important}.lunar .page-size span{display:inline-block}.lunar .page-size span:first-of-type{margin-right:5px}.lunar .page-size span:last-of-type{margin-left:5px}.lunar .overflow-cell span{color:#666}.lunar .icon:before{font-size:1.3rem;color:#555}.lunar .card-table-header-row{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-webkit-box-pack:center;justify-content:center;padding:5px 0}.lunar .card-table-header-row.row-expanded{border-bottom-left-radius:0;border-bottom-right-radius:0}.lunar tbody .card-table-data-row:first-child{margin-top:8px!important}.lunar .card-table-detail-row{margin-bottom:8px!important}.lunar .card-table-data-row{background:#fff;min-height:56px;box-shadow:0 1px 4px 0 rgba(12,12,13,.2);-webkit-transition:.3s ease-in-out;transition:.3s ease-in-out;border:0;border-radius:5px;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;margin-top:8px}.lunar .card-table-data-row:nth-child(odd){background:#fff}.lunar .card-table-column-header{padding:7px 20px 5px;background-color:#fff;color:#666;text-transform:uppercase;font-weight:400;-webkit-box-flex:1;flex-grow:1;flex:1;text-align:left}.lunar .card-table-column-header .card-header-label{white-space:nowrap}.lunar .card-table-column-header.sorting{background-color:#fff}.lunar .card-table-column-header:not(:last-of-type){border-right:none}.lunar .card-table-column-header .icon-gear{-webkit-animation:none;animation:none}.lunar .card-table-column-header .icon-gear::before{margin-top:-2px;margin-left:3px;float:right}.lunar .card-table-column-header.expand{min-width:68px;max-width:68px;width:68px;border-radius:4px}.lunar .card-table-column-header.actions{max-width:55px;position:relative}.lunar .checkbox-column{padding:0;position:relative}.lunar .checkbox-column .custom-control.custom-checkbox{margin:auto;-webkit-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%);top:50%;left:50%;position:absolute;min-height:auto}.lunar .checkbox-column .custom-control.custom-checkbox .custom-control-indicator{margin:0}.lunar .card-table-cell{-webkit-box-flex:1;flex-grow:1;flex:1;text-align:left;font-size:14px}.lunar .card-table-cell.actions{max-width:55px;position:relative}.lunar .card-table-cell.actions .actions-btn-wrapper{width:40px;height:40px;padding:7px;border-radius:4px}.lunar .card-table-cell.actions .actions-btn-wrapper--enabled{cursor:pointer}.lunar .card-table-cell.actions .actions-btn-wrapper--enabled:hover{background-color:#f8f8f8}.lunar .card-table-cell.expand{min-width:65px;width:65px;max-width:65px;padding:20px 0 17px}.lunar .card-table-cell.expand .icon::after{float:left;font-family:\"Expert Sans\";color:#555}.lunar .card-table-cell.expand .ico-chevron-down::after{margin-left:2px}.lunar .card-table-cell.expand .ico-chevron-up::after{margin-left:5px}.lunar .card-table-cell .custom-checkbox{margin-top:12px}.lunar .noDataContainer{text-align:center;margin:1em 0}.lunar .noDataContainer__icon::before{font-family:feather;display:inline-block;color:#000;font-size:3em;padding:0 .5em;vertical-align:text-bottom}.lunar .noDataContainer__icon.info::before{content:\"\\e974\"}.lunar .noDataContainer__icon.error::before{content:\"\\e90b\"}.lunar .card-table,.lunar .grid-table{border-collapse:collapse;width:100%;font-size:.8rem;border-radius:4px;border-style:hidden;box-shadow:0 0 0 .5px #ddd}.lunar .card-table .grid-table-column-header,.lunar .grid-table .grid-table-column-header{background:#fff;color:#2d2323;font-weight:600;font-size:14px;cursor:pointer;padding:16px;white-space:nowrap;text-transform:capitalize;position:relative;min-height:56px}.lunar .card-table .grid-table-column-header:hover .ico-sort,.lunar .card-table .grid-table-column-header:hover .ico-sort-down,.lunar .card-table .grid-table-column-header:hover .ico-sort-up,.lunar .grid-table .grid-table-column-header:hover .ico-sort,.lunar .grid-table .grid-table-column-header:hover .ico-sort-down,.lunar .grid-table .grid-table-column-header:hover .ico-sort-up{display:inline-block}.lunar .card-table .grid-table-column-header:not(:last-of-type),.lunar .grid-table .grid-table-column-header:not(:last-of-type){border-right:.5px solid #ddd}.lunar .card-table .grid-table-column-header.sorting,.lunar .grid-table .grid-table-column-header.sorting{background-color:#fbfaf9}.lunar .card-table .grid-table-column-header.sorting .ico-sort,.lunar .card-table .grid-table-column-header.sorting .ico-sort-down,.lunar .card-table .grid-table-column-header.sorting .ico-sort-up,.lunar .grid-table .grid-table-column-header.sorting .ico-sort,.lunar .grid-table .grid-table-column-header.sorting .ico-sort-down,.lunar .grid-table .grid-table-column-header.sorting .ico-sort-up{display:inline-block}.lunar .card-table .grid-table-column-header.expand,.lunar .grid-table .grid-table-column-header.expand{min-width:65px;width:65px;max-width:65px;text-align:center}.lunar .card-table .grid-table-column-header .sort-space,.lunar .grid-table .grid-table-column-header .sort-space{width:16px;height:16px;display:inline-block}.lunar .card-table .grid-table-column-header .ico-sort,.lunar .card-table .grid-table-column-header .ico-sort-down,.lunar .card-table .grid-table-column-header .ico-sort-up,.lunar .grid-table .grid-table-column-header .ico-sort,.lunar .grid-table .grid-table-column-header .ico-sort-down,.lunar .grid-table .grid-table-column-header .ico-sort-up{-webkit-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%);top:50%;right:0;position:absolute;font-size:20px;display:none}.lunar .card-table .grid-table-column-header:first-child,.lunar .card-table .grid-table-column-header:last-child,.lunar .grid-table .grid-table-column-header:first-child,.lunar .grid-table .grid-table-column-header:last-child{border-radius:4px}.lunar .card-table .card-table-cell,.lunar .card-table .grid-table-cell,.lunar .grid-table .card-table-cell,.lunar .grid-table .grid-table-cell{padding:16px;position:relative}.lunar .card-table .grid-table-cell.pointer,.lunar .card-table .pointer.card-table-cell,.lunar .grid-table .grid-table-cell.pointer,.lunar .grid-table .pointer.card-table-cell{cursor:pointer}.lunar .card-table .expand.card-table-cell,.lunar .card-table .grid-table-cell.expand,.lunar .grid-table .expand.card-table-cell,.lunar .grid-table .grid-table-cell.expand{min-height:56px;min-width:65px;width:65px;max-width:65px;text-align:center;border-left:.5px solid rgba(12,12,13,.1);font-weight:700;z-index:1}.lunar .card-table .card-table-detail-row,.lunar .card-table .grid-table-detail-row,.lunar .grid-table .grid-table-detail-row{padding:0;background-color:#fff}.lunar .card-table .grid-table-detail-cell,.lunar .grid-table .grid-table-detail-cell{border-top:1px solid #ddd}.lunar .card-table .grid-table-data-row,.lunar .grid-table .grid-table-data-row{border-top:1px solid #ddd;background:#fff}.lunar .card-table tbody tr:last-child td:first-child,.lunar .card-table tbody tr:last-child td:last-child,.lunar .grid-table tbody tr:last-child td:first-child,.lunar .grid-table tbody tr:last-child td:last-child{border-radius:4px}.lunar .lunar-expanded-icon-down{width:30px;height:30px;display:inline-block;background-repeat:no-repeat;background-image:url(\"data:image/svg+xml,%3Csvg id='Icons' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20.1 20.1'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:none;stroke:%23555;stroke-linecap:square;stroke-miterlimit:10;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Eicon%5But-di%5D_chevron-down-arrow%3C/title%3E%3Cpath class='cls-1' d='M15.25,7.25l-5.2,5.5-5.3-5.5'/%3E%3C/svg%3E\")}.lunar .lunar-expanded-icon-up{width:30px;height:30px;display:inline-block;background-repeat:no-repeat;background-image:url(\"data:image/svg+xml,%3Csvg id='Icons' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20.1 20.1'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:none;stroke:%23555;stroke-linecap:square;stroke-miterlimit:10;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Eicon%5But-di%5D_chevron-up-arrow%3C/title%3E%3Cpath class='cls-1' d='M4.75,12.75,10,7.25l5.2,5.5'/%3E%3C/svg%3E\")}.horizontal-scroll{display:block;overflow-x:auto;white-space:nowrap;box-shadow:0 0 1px .5px #ddd!important}::-webkit-scrollbar{-webkit-appearance:none;width:5px}::-webkit-scrollbar-thumb{border-radius:0;background-color:#736464}.lunar .card-table{border-collapse:separate;box-shadow:none;border:none;overflow:unset}.lunar .card-table thead{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;background-color:#fff;border:.5px solid #ddd;border-radius:4px;overflow:hidden}.lunar .card-table tbody{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}.lunar .card-table .card-table-detail-row{position:relative;border-radius:0 0 5px 5px;margin-top:0;display:-webkit-box;display:flex;background-color:#fff!important}.lunar .card-table .card-table-detail-row:before{content:' ';width:100%;height:10px;background:#fff;position:absolute;z-index:1;top:-11px;left:0}.lunar .card-table .card-table-detail-cell{-webkit-box-flex:1;flex-grow:1;flex:1;border:0;box-shadow:0 4px 12px 0 rgba(12,12,13,.2);border-radius:0 0 5px 5px}.lunar .card-table .row-expanded{margin-top:16px!important;box-shadow:0 4px 12px 0 rgba(12,12,13,.2)!important;border-radius:5px 5px 0 0!important}.pager-container{padding:2rem 0}.pager-container select{background:#fff;box-shadow:1px 1px rgba(0,0,0,.1);border:0}.page-information{text-align:center;padding:1rem}.page-information p{font-weight:400;font-size:1.2rem;padding:.5rem 0;margin:0}@-webkit-keyframes mega-menu-slide-down{from{opacity:0;-webkit-transform:scale(0);transform:scale(0)}to{opacity:1;-webkit-transform:scale(1,1);transform:scale(1,1)}}@keyframes mega-menu-slide-down{from{opacity:0;-webkit-transform:scale(0);transform:scale(0)}to{opacity:1;-webkit-transform:scale(1,1);transform:scale(1,1)}}@-webkit-keyframes scale-in-ver-top{0%{-webkit-transform:scaleY(0);transform:scaleY(0);-webkit-transform-origin:100% 0;transform-origin:100% 0;opacity:0}100%{-webkit-transform:scaleY(1);transform:scaleY(1);-webkit-transform-origin:100% 0;transform-origin:100% 0;opacity:1}}@keyframes scale-in-ver-top{0%{-webkit-transform:scaleY(0);transform:scaleY(0);-webkit-transform-origin:100% 0;transform-origin:100% 0;opacity:0}100%{-webkit-transform:scaleY(1);transform:scaleY(1);-webkit-transform-origin:100% 0;transform-origin:100% 0;opacity:1}}@-webkit-keyframes fadeInLeft{0%{opacity:0;-webkit-transform:translateY(-32px);transform:translateY(-32px)}100%{opacity:1;-webkit-transform:translateY(10px);transform:translateY(10px)}}@keyframes fadeInLeft{0%{opacity:0;-webkit-transform:translateY(-32px);transform:translateY(-32px)}100%{opacity:1;-webkit-transform:translateY(10px);transform:translateY(10px)}}"]
                }] }
    ];
    LunarComponent.propDecorators = {
        modalLoaderContent: [{ type: ViewChild, args: ['modalLoaderContent', { static: true },] }],
        overFlowDetailTemplate: [{ type: ViewChild, args: ['overflow', { static: true },] }],
        settingsComponent: [{ type: ViewChild, args: [SettingsComponent, { static: false },] }],
        titleHostReference: [{ type: ViewChild, args: ['titleHost', { read: ViewContainerRef, static: true },] }],
        columns: [{ type: Input }],
        expandableType: [{ type: Input }],
        intialSort: [{ type: Input }],
        overFlowColumns: [{ type: Input }],
        PageSizeOptions: [{ type: Input }],
        rows: [{ type: Input }],
        total: [{ type: Input }],
        actions: [{ type: Input }],
        actionsCondition: [{ type: Input }],
        cardView: [{ type: Input }],
        loading: [{ type: Input }],
        horizontalScroll: [{ type: Input }],
        noDataMessage: [{ type: Input }],
        paging: [{ type: Input }],
        selectable: [{ type: Input }],
        settingsPanelEnabled: [{ type: Input }],
        showExpandButtons: [{ type: Input }],
        sortable: [{ type: Input }],
        sortCustom: [{ type: Input }],
        titleTemplate: [{ type: Input }],
        rowDetailFooter: [{ type: Input }],
        rowDetailHeader: [{ type: Input }],
        UniqueKey: [{ type: Input }],
        PersistColumnSettings: [{ type: Input }],
        expandOnProperty: [{ type: Input }],
        additionalCssClasses: [{ type: Input }],
        rowDetail: [{ type: Input }],
        sortChanged: [{ type: Output }],
        onPageSizeChanged: [{ type: Output }],
        onPageChanged: [{ type: Output }],
        onRowSelectionChanged: [{ type: Output }],
        onRowEdited: [{ type: Output }],
        onRowsEdited: [{ type: Output }]
    };
    return LunarComponent;
}());
if (false) {
    /** @type {?} */
    LunarComponent.prototype.modalLoaderContent;
    /** @type {?} */
    LunarComponent.prototype.overFlowDetailTemplate;
    /** @type {?} */
    LunarComponent.prototype.settingsComponent;
    /** @type {?} */
    LunarComponent.prototype.titleHostReference;
    /** @type {?} */
    LunarComponent.prototype.actions;
    /** @type {?} */
    LunarComponent.prototype.actionsCondition;
    /** @type {?} */
    LunarComponent.prototype.cardView;
    /** @type {?} */
    LunarComponent.prototype.loading;
    /** @type {?} */
    LunarComponent.prototype.horizontalScroll;
    /** @type {?} */
    LunarComponent.prototype.noDataMessage;
    /** @type {?} */
    LunarComponent.prototype.paging;
    /** @type {?} */
    LunarComponent.prototype.selectable;
    /** @type {?} */
    LunarComponent.prototype.settingsPanelEnabled;
    /** @type {?} */
    LunarComponent.prototype.showExpandButtons;
    /** @type {?} */
    LunarComponent.prototype.sortable;
    /** @type {?} */
    LunarComponent.prototype.sortCustom;
    /** @type {?} */
    LunarComponent.prototype.titleTemplate;
    /** @type {?} */
    LunarComponent.prototype.rowDetailFooter;
    /** @type {?} */
    LunarComponent.prototype.rowDetailHeader;
    /**
     * Allows user to persist some settings, IF this unique
     * key is present. For example, persist column order to local storage.
     * @type {?}
     */
    LunarComponent.prototype.UniqueKey;
    /**
     * If true, we persist the selected columns to local storage
     * @type {?}
     */
    LunarComponent.prototype.PersistColumnSettings;
    /**
     * If this is set AND the expand state = ROW_DEFINED,
     * We can use this property to dermine if a row is expandable
     * or now
     * @type {?}
     */
    LunarComponent.prototype.expandOnProperty;
    /**
     * Allows for additional classes to be injected to the data table
     * for a bit more customization.
     * @type {?}
     */
    LunarComponent.prototype.additionalCssClasses;
    /**
     * An input template to overide the default template of the row detail,
     * when the row is expanded.
     * @type {?}
     */
    LunarComponent.prototype.rowDetail;
    /** @type {?} */
    LunarComponent.prototype.sortChanged;
    /** @type {?} */
    LunarComponent.prototype.onPageSizeChanged;
    /** @type {?} */
    LunarComponent.prototype.onPageChanged;
    /** @type {?} */
    LunarComponent.prototype.onRowSelectionChanged;
    /** @type {?} */
    LunarComponent.prototype.onRowEdited;
    /** @type {?} */
    LunarComponent.prototype.onRowsEdited;
    /** @type {?} */
    LunarComponent.prototype.columnsInternal;
    /** @type {?} */
    LunarComponent.prototype.currentSortProperty;
    /** @type {?} */
    LunarComponent.prototype.defaultPageSize;
    /** @type {?} */
    LunarComponent.prototype.expandableTypeInternal;
    /** @type {?} */
    LunarComponent.prototype.expandableTypesEnum;
    /** @type {?} */
    LunarComponent.prototype.hiddenColumns;
    /** @type {?} */
    LunarComponent.prototype.isAllRowsExpandable;
    /** @type {?} */
    LunarComponent.prototype.isAllRowsSelected;
    /** @type {?} */
    LunarComponent.prototype.modalLoaderTitle;
    /** @type {?} */
    LunarComponent.prototype.modalLoaderBody;
    /** @type {?} */
    LunarComponent.prototype.page;
    /** @type {?} */
    LunarComponent.prototype.pageSizes;
    /** @type {?} */
    LunarComponent.prototype.pagingEnum;
    /** @type {?} */
    LunarComponent.prototype.rowsInternal;
    /** @type {?} */
    LunarComponent.prototype.rowExpandedState;
    /** @type {?} */
    LunarComponent.prototype.rowExpandStatesEnum;
    /**
     * @type {?}
     * @private
     */
    LunarComponent.prototype.defaultPageSizes;
    /**
     * @type {?}
     * @private
     */
    LunarComponent.prototype.pageSizeBackup;
    /**
     * @type {?}
     * @private
     */
    LunarComponent.prototype.isPaging;
    /**
     * @type {?}
     * @private
     */
    LunarComponent.prototype.isOverFlowEnabled;
    /**
     * @type {?}
     * @private
     */
    LunarComponent.prototype.originalRows;
    /**
     * @type {?}
     * @private
     */
    LunarComponent.prototype.originalColumns;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pagination/pagination.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LunarPaginationComponent = /** @class */ (function () {
    function LunarPaginationComponent() {
        this.goPrev = new EventEmitter();
        this.goNext = new EventEmitter();
        this.goPage = new EventEmitter();
    }
    /**
     * @return {?}
     */
    LunarPaginationComponent.prototype.getMin = /**
     * @return {?}
     */
    function () {
        return this.perPage * this.page - this.perPage + 1;
    };
    /**
     * @return {?}
     */
    LunarPaginationComponent.prototype.getMax = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var max = this.perPage * this.page;
        if (max > this.count) {
            max = this.count;
        }
        return max;
    };
    /**
     * @param {?} n
     * @return {?}
     */
    LunarPaginationComponent.prototype.onPage = /**
     * @param {?} n
     * @return {?}
     */
    function (n) {
        this.page = n;
        this.goPage.emit(n);
    };
    /**
     * @return {?}
     */
    LunarPaginationComponent.prototype.onPrev = /**
     * @return {?}
     */
    function () {
        this.goPrev.emit(true);
    };
    /**
     * @param {?} next
     * @return {?}
     */
    LunarPaginationComponent.prototype.onNext = /**
     * @param {?} next
     * @return {?}
     */
    function (next) {
        this.goNext.emit(next);
    };
    /**
     * @return {?}
     */
    LunarPaginationComponent.prototype.totalPages = /**
     * @return {?}
     */
    function () {
        return Math.ceil(this.count / this.perPage) || 0;
    };
    /**
     * @return {?}
     */
    LunarPaginationComponent.prototype.lastPage = /**
     * @return {?}
     */
    function () {
        return this.page >= this.totalPages();
        // return this.perPage * this.page > this.count;
    };
    /**
     * @return {?}
     */
    LunarPaginationComponent.prototype.getPages = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var c = Math.ceil(this.count / this.perPage);
        /** @type {?} */
        var p = this.page || 1;
        /** @type {?} */
        var pagesToShow = this.pagesToShow || 9;
        /** @type {?} */
        var pages = [];
        pages.push(p);
        /** @type {?} */
        var times = pagesToShow - 1;
        for (var i = 0; i < times; i++) {
            if (pages.length < pagesToShow) {
                if (Math.min.apply(null, pages) > 1) {
                    pages.push(Math.min.apply(null, pages) - 1);
                }
            }
            if (pages.length < pagesToShow) {
                if (Math.max.apply(null, pages) < c) {
                    pages.push(Math.max.apply(null, pages) + 1);
                }
            }
        }
        pages.sort((/**
         * @param {?} a
         * @param {?} b
         * @return {?}
         */
        function (a, b) { return a - b; }));
        return pages;
    };
    LunarPaginationComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lunar-pagination',
                    template: "\n\t\t<div\n\t\t\tclass=\"pagination\"\n\t\t\t*ngIf=\"count > 0\"\n\t\t\t[class.pagination-large]=\"totalPages() > 10\"\n\t\t>\n\t\t\t<!--<div class=\"description\">\n                <span class=\"page-counts\">{{ getMin() }} - {{ getMax() }} of {{ count }}</span>\n                <span class=\"page-totals\">--{{ totalPages() }} pages</span>\n            </div>-->\n\t\t\t<div class=\"numbers\">\n\t\t\t\t<button\n\t\t\t\t\t(click)=\"onPage(page - 1)\"\n\t\t\t\t\t[disabled]=\"page === 1 || loading\"\n\t\t\t\t\t[ngClass]=\"{ disabled: page === 1 || loading }\"\n\t\t\t\t>\n\t\t\t\t\t<span class=\"icon icon-chevron-left\"></span>\n\t\t\t\t</button>\n\n\t\t\t\t<ng-container\n\t\t\t\t\t*ngFor=\"let pageNum of getPages(); let index = index\"\n\t\t\t\t>\n\t\t\t\t\t<button\n\t\t\t\t\t\t(click)=\"onPage(pageNum)\"\n\t\t\t\t\t\t[ngClass]=\"{\n\t\t\t\t\t\t\tactive: pageNum === page,\n\t\t\t\t\t\t\tdisabled: loading\n\t\t\t\t\t\t}\"\n\t\t\t\t\t>\n\t\t\t\t\t\t<span>{{ pageNum }}</span>\n\t\t\t\t\t</button>\n\n\t\t\t\t\t<ng-container *ngIf=\"index === 5\">\n\t\t\t\t\t\t<span class=\"gap\">...</span>\n\t\t\t\t\t</ng-container>\n\t\t\t\t</ng-container>\n\n\t\t\t\t<button\n\t\t\t\t\t(click)=\"onPage(page + 1)\"\n\t\t\t\t\t[disabled]=\"lastPage() || loading\"\n\t\t\t\t\t[ngClass]=\"{ disabled: lastPage() || loading }\"\n\t\t\t\t>\n\t\t\t\t\t<span class=\"icon icon-chevron-right\"></span>\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</div>\n\t",
                    styles: [":host .pagination .numbers{float:right}:host .pagination button{width:36px;height:34px;color:#797373;background:#fff;border-radius:4px;box-shadow:1px 1px rgba(0,0,0,.1);border:0;margin:0 5px 0 0;outline:0;font-weight:300;font-size:16px}:host .pagination button span{display:inline-block}:host .pagination button.disabled{background:#f3f3f3;border:1px solid #f3f3f3}:host .pagination button.active{color:#fff;font-weight:500;border:1px solid #af144b;background-color:#af144b}:host .pagination button:last-child{margin:0}:host .pagination .gap{font-size:20px;line-height:0;height:16px;margin-right:5px;color:rgba(0,0,0,.5);top:-6px;position:relative;display:inline-block}:host .pagination.pagination-large button{display:none}:host .pagination.pagination-large button:nth-child(-n+5){display:inline-block}:host .pagination.pagination-large button:nth-last-child(-n+5){display:inline-block}"]
                }] }
    ];
    /** @nocollapse */
    LunarPaginationComponent.ctorParameters = function () { return []; };
    LunarPaginationComponent.propDecorators = {
        page: [{ type: Input }],
        count: [{ type: Input }],
        perPage: [{ type: Input }],
        loading: [{ type: Input }],
        pagesToShow: [{ type: Input }],
        goPrev: [{ type: Output }],
        goNext: [{ type: Output }],
        goPage: [{ type: Output }]
    };
    return LunarPaginationComponent;
}());
if (false) {
    /** @type {?} */
    LunarPaginationComponent.prototype.page;
    /** @type {?} */
    LunarPaginationComponent.prototype.count;
    /** @type {?} */
    LunarPaginationComponent.prototype.perPage;
    /** @type {?} */
    LunarPaginationComponent.prototype.loading;
    /** @type {?} */
    LunarPaginationComponent.prototype.pagesToShow;
    /** @type {?} */
    LunarPaginationComponent.prototype.goPrev;
    /** @type {?} */
    LunarPaginationComponent.prototype.goNext;
    /** @type {?} */
    LunarPaginationComponent.prototype.goPage;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/lunar.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SolarLunarModule = /** @class */ (function () {
    function SolarLunarModule() {
    }
    SolarLunarModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        NgbModule
                    ],
                    exports: [
                        LunarComponent,
                        LunarPaginationComponent,
                        SettingsComponent
                    ],
                    declarations: [
                        LunarComponent,
                        LunarPaginationComponent,
                        SettingsComponent
                    ]
                },] }
    ];
    return SolarLunarModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: solar-lunar.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { BuiltInTemplates, Column, ColumnAlignment, ExpandableTypes, LunarComponent, LunarPaginationComponent, Page, Paging, PersistedColumnsSet, RowExpandStates, SelectableTypes, SettingsPanelConfig, SolarLunarModule, SortDirection, SettingsComponent as ɵa };
//# sourceMappingURL=solar-lunar.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@solar/lunar/fesm5/solar-lunar.js
// module id = ./node_modules/@solar/lunar/fesm5/solar-lunar.js
// module chunks = 0